import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, isDevMode, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { AppHttpInterceptor, SKIP_FORBIDDEN_LOGOUT, SKIP_MTS_SAME_LOGIN } from '@authentication';
import { HttpErrorInterceptor, UserCheckedInterceptor } from '@shared';
import { EasyEnvironment } from '@shared-types';
import { environment } from '../environments/environment';
import { EasyKalaEnvironment } from '../environments/environment.model';
import { appRoutes } from './app.routes';
import { provideDeviceId } from './core/device/device-id.providers';
import { AppHeadersInterceptor } from './core/http/app-headers.interceptor';
import { KalaSessionInterceptor } from './core/http/kala-session.interceptor';
import { provideEventDrivenStartup } from './providers/event-driven-startup.providers';

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideRouter(appRoutes, withComponentInputBinding()),
		provideHttpClient(
			withInterceptors([
				AppHeadersInterceptor,
				KalaSessionInterceptor,
				UserCheckedInterceptor,
				AppHttpInterceptor,
				HttpErrorInterceptor
			])
		),
		provideDeviceId(),
		provideEventDrivenStartup(),
		/**
		 * A customer without a کد بورس کالا is refused by the commodity endpoints rather than by us,
		 * and that refusal arrives as a 403 — indistinguishable from a dead session, which
		 * `AppHttpInterceptor` would sign them out over. Kala silences that guard and re-decides in
		 * `createKalaForbiddenLogoutInterceptor`, where the profile is available to tell the two apart.
		 */
		{ provide: SKIP_FORBIDDEN_LOGOUT, useValue: true },
		{ provide: SKIP_MTS_SAME_LOGIN, useValue: true },
		/**
		 * Registration is deferred so the worker's install never competes with the first paint or
		 * the OIDC redirect for bandwidth. `isDevMode()` keeps it off the `development-*`
		 * configurations — the ones `serve` builds — where a cached shell would hide every edit.
		 */
		provideServiceWorker('ngsw-worker.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerWithDelay:30000'
		}),
		{
			provide: EasyKalaEnvironment,
			useValue: {
				...environment
			}
		},
		{
			provide: EasyEnvironment,
			useValue: {
				...environment
			}
		}
	]
};
